export default "__VITE_ASSET__7d8c86e6__"